import api from './client'

export type TaskType = 'meeting' | 'reminder'
export type TaskRefType = 'lead' | 'deal' | 'contact'
export type TaskStatus = 'open' | 'completed' | 'cancelled'

export interface CalendarTask {
  id: string
  companyId: string
  type: TaskType
  refType: TaskRefType | null
  refId: string | null
  linkedRecordName: string | null
  title: string
  description: string | null
  dueDate: string | null
  isAllDay: boolean
  startAt: string | null
  endAt: string | null
  assignedTo: string | null
  assignedUser?: { id: string; firstName: string; lastName: string } | null
  status: TaskStatus
  completedAt: string | null
  createdBy: string
  createdByUser?: { id: string; firstName: string; lastName: string } | null
  createdAt: string
}

export interface CreateCalendarTaskDto {
  title: string
  type?: TaskType
  isAllDay?: boolean
  dueDate?: string
  startAt?: string
  endAt?: string
  description?: string
  assignedTo?: string
  refType?: TaskRefType
  refId?: string
}

export interface UpdateCalendarTaskDto extends Partial<CreateCalendarTaskDto> {
  status?: TaskStatus
}

export interface LinkableResult {
  id: string
  type: TaskRefType
  label: string
  sub?: string
}

export const calendarApi = {
  list: (companyId: string, params: { from: string; to: string; userId?: string }) =>
    api.get<CalendarTask[]>(`/companies/${companyId}/calendar`, { params }),

  getOne: (companyId: string, taskId: string) =>
    api.get<CalendarTask>(`/companies/${companyId}/calendar/${taskId}`),

  listDay: (companyId: string, params: { date: string; userId?: string }) =>
    api.get<CalendarTask[]>(`/companies/${companyId}/calendar/day`, { params }),

  searchLinkable: (companyId: string, params: { q?: string; type?: TaskRefType }) =>
    api.get<LinkableResult[]>(`/companies/${companyId}/calendar/search-linkable`, { params }),

  searchEvents: (companyId: string, q: string) =>
    api.get<CalendarTask[]>(`/companies/${companyId}/calendar/search`, { params: { q } }),

  create: (companyId: string, dto: CreateCalendarTaskDto) =>
    api.post<CalendarTask>(`/companies/${companyId}/calendar`, dto),

  update: (companyId: string, taskId: string, dto: UpdateCalendarTaskDto) =>
    api.patch<CalendarTask>(`/companies/${companyId}/calendar/${taskId}`, dto),

  remove: (companyId: string, taskId: string) =>
    api.delete(`/companies/${companyId}/calendar/${taskId}`),
}
